"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutSectionMarkBox = void 0;
var tslib_1 = require("tslib");
var layout_box_1 = require("./layout-box");
var layout_page_break_box_1 = require("./layout-page-break-box");
var LayoutSectionMarkBox = (function (_super) {
    tslib_1.__extends(LayoutSectionMarkBox, _super);
    function LayoutSectionMarkBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LayoutSectionMarkBox.prototype, "isSectionBreakBox", {
        get: function () { return true; },
        enumerable: false,
        configurable: true
    });
    LayoutSectionMarkBox.prototype.clone = function () {
        var newObj = new LayoutSectionMarkBox(this.characterProperties, this.colorInfo);
        newObj.copyFrom(this);
        return newObj;
    };
    LayoutSectionMarkBox.prototype.getType = function () {
        return layout_box_1.LayoutBoxType.SectionMark;
    };
    LayoutSectionMarkBox.prototype.getHiddenText = function () {
        return "::::::::Section Break::::::::";
    };
    return LayoutSectionMarkBox;
}(layout_page_break_box_1.LayoutPageBreakBox));
exports.LayoutSectionMarkBox = LayoutSectionMarkBox;
